$(document).ready(function() {	
	$('.brzi-ispravak input.ispravak').click(function(e){	
		$(this).select();
	});
		
	$('.brzi-ispravak input.ispravak').keyup(function(e){
		if(e.which == 13) { //enter
			var idPosla = parseInt($(this).val().replace(/[^0-9]/g, ''));
			if (!isNaN(idPosla)) {
				$(this).val(idPosla);
		        kontorouter.goto('posao/ispravak/'+idPosla, false);
		        $(this).val("");
		    }
		}
	});
	
	$('.brzi-ispravak a.posaoBrziLink').on('click',function() {
	    var idPosla = parseInt($('.brzi-ispravak input.ispravak').val().replace(/[^0-9]/g, ''));
	    $('.brzi-ispravak input.ispravak').val("");
		if (!isNaN(idPosla)) {
			kontorouter.gotoLocationNewtab('posao/ispravak/'+idPosla, false);
		}else{
			kontorouter.gotoLocationNewtab('posao/unos/', false);
		}
	});
	
	$('.brzi-ispravak a.posaoDodajPracenjeLink').on('click',function() {
	    var idPosla = parseInt($('.brzi-ispravak input.ispravak').val().replace(/[^0-9]/g, ''));
	    $('.brzi-ispravak input.ispravak').val("");
		if (!isNaN(idPosla)) {
			konto.ek.utils.pratimDodajPosaoClick(idPosla);	
		}else{
			kontorouter.gotoLocationNewtab('posao/pratim', false);
		}
	});
		
	$('#posljednjiPoslovi').click(function() {
		if ($(this).parent().hasClass('open'))
			return true; //otvoren je menu, preskacem
		
		napuniPosljednjePoslove();
	});

	$('#panelPoslovi').click(function() {
		if ($(this).parent().hasClass('open'))
			return true; //otvoren je menu, preskacem
		
		napuniPanelPoslove();
	});
	
	$('#dropdown-posljednji').on('click', 'a.posaoPanelLink', function() {
		var idPosla = $(this).attr('data-posao');
		kontorouter.gotoLocation('posao/ispravak/'+idPosla, false);		
	});
	
	function ClearObavijestZaPosaoDjelat(posao, refresh){
		var userId_Obavijest = $("#spanPanel").data("djelatId");
		return konto.ek.api.ClearObavijestZaPosaoDjelat(posao, userId_Obavijest)
			.then(function(){
				if (refresh){
					SetObavijestZaPosaoDjelat();
				}
			});
	}
	
	function SetObavijestZaPosaoDjelat(){
        var userId_Obavijest = $("#spanPanel").data("djelatId");
        konto.ek.api.GetBrojObavijesti(userId_Obavijest)
            .then(function (data) 
            { 

                var olddata = $("#spanPanel").data("brojObavijesti");
                var intervalID = $("#spanPanel").data("intervalID");
                
                if(typeof data === 'object')
                {
                    clearInterval(intervalID);
                    $("#spanPanel").data("error", 1);                    
                    return true;
                }                           
                        
                if((data != "0") && (typeof data == "string"))
                {           
                    $("#spanPanel").html("Panel (" + data + ")");  
                    $("#panelPoslovi").addClass("novaObavijest");

                    if(data != olddata)
                    {
                        $("#panelPoslovi").addClass("konto-blink");  
                        setTimeout(function(){
                            $("#panelPoslovi").removeClass("konto-blink"); 
                        }, 10000);
                    }
                }else{
                    $("#spanPanel").html("Panel");
                    $("#panelPoslovi").removeClass("novaObavijest");            
                    $("#panelPoslovi").removeClass("konto-blink");                      
                }
                        
                $("#spanPanel").data("brojObavijesti", data);
                $("#spanPanel").data("djelatId", userId_Obavijest);
                $("#spanPanel").data("error", 0);                                       
            });
	}
	
	$('#dropdown-posaopanel').on('click', 'a.posaoPanelLink', function() {
		var idPosla = $(this).attr('data-posao');
		var novaObavijest = $(this).hasClass('novaObavijest');
		if (novaObavijest == true){
			ClearObavijestZaPosaoDjelat(idPosla, true).then(function(){
			  kontorouter.gotoLocation('posao/ispravak/'+idPosla, false);  
			});		
		}else{
		  kontorouter.gotoLocation('posao/ispravak/'+idPosla, false);	
		}	
	});
	
	$('#dropdown-posaopanel').on('click', 'i.posaoPanelBrisi', function() {
		var idPosla = $(this).parent().find('a.posaoPanelLink').attr('data-posao');
        var novaObavijest = $(this).parent().children().first().hasClass('novaObavijest');
        if (novaObavijest == true){
            ClearObavijestZaPosaoDjelat(idPosla, true);     
        } 
        var idPosaoPanela = $(this).parent().attr('data-posao-panel');
        var chale = $(this).parent();
        
        $.dsDirectCall({
            method: "PosaoPanelObrisi",
            params: [idPosaoPanela],
            done: function (data) {
                chale.fadeOut('fast', function() { chale.remove(); });
            }
        });
        
        return false;
		
	});
	
    $('#dropdown-posljednji').on('click', 'i.posaoPanelLinkNewTab', function() {
        
        var idPosla = $(this).parent().find('a.posaoPanelLink').attr('data-posao');
        kontorouter.gotoLocationNewtab('posao/ispravak/'+idPosla, false);   
    });
	
	$('#dropdown-posaopanel').on('click', 'i.posaoPanelLinkNewTab', function() {
		var idPosla = $(this).parent().find('a.posaoPanelLink').attr('data-posao');
		var novaObavijest = $(this).hasClass('novaObavijest');
		if (novaObavijest == true){
			ClearObavijestZaPosaoDjelat(idPosla, false);		
		}
		kontorouter.gotoLocationNewtab('posao/ispravak/'+idPosla, false);	
	});	
	
	$('#dropdown-posaopanel').on('click', 'button.btnDodajNaPanel', function() {
		var sifarnik = konto.KontoBase.getByControllerAction('posao','pregled');
		var ispravak = konto.KontoBase.getByControllerAction('posao','ispravak');
		
		if (isset(sifarnik) && !empty(sifarnik)) {			
			var idPosla = sifarnik.kontoGrid.getSelectedData().POSAO;		
			//var title = sifarnik.kontoGrid.getSelectedData().ZADOPIS;
			
		} else if (isset(ispravak) && !empty(ispravak)) {			
			var data = $.dsObjectToJS(ispravak.dataObject);
			var idPosla = data.POSAO;		
			//var title = data.ZADOPIS;

		} else if (Posao.dataset.FPosao) { //fix za bug kada kreiraš novi posao i spremiš ga sa 'Upiši, ostani', te odmah klikneš na "Dodaj na panel"
			var idPosla = Posao.dataset.FPosao;		
		} else {
			
			$.dialogInfo({
				content: "Nije odabran niti jedan posao!",	
				width: "500px"
			});
		}
				
		$.dsDirectCall({
            method: "PosaoPanelDodaj",
            params: [idPosla],
            done: function (data) {
				napuniPosljednjePoslove();
				SetObavijestZaPosaoDjelat();
            }
        });
        
	});
	
	$('#dropdown-posaopanel').on('click', 'button.btnPanelObrisiZatvorene', function() {
	    var pka = ppZatvoreni.join();
	    if (pka != ''){
            $.dsDirectCall({
                method: "PosaoPanelObrisiZatvorenePoslove",
                params: [ pka ],
                done: function (data) {
                    ppZatvoreni = [];
                    napuniPosljednjePoslove();
                    SetObavijestZaPosaoDjelat();
                }
            });
        }
	});

	function napuniPosljednjePoslove() {      
        //tip 1 povijest  //async
        konto.ek.api.DohvatiPoslovePanel(1).then(function(data) {
        	var html = '';

        	if (data === null || !isset(data))
    			return;
				
			if (typeof data === 'object' && data.error)
			return;				

			$.each(data, function(key, val) {
				var item = dodatnaKlasa = naslov = '';
					
					item  = '<li title="'+naslov+'" class="nav-item user-data-button ppanel-list" data-posao-panel="'+val.POSAOPANEL+'">';
					item += 	'<a href="#" data-posao="'+val.POSAO+'" class="nav-link posaoPanelLink" style="color: black">'+ 
									'<span class="idPosla">' + val.POSAO + '</span> ' + '<span class="nazivAplikacije">'+val.PROG + '</span> ' +
									'<b class="partner">' +val.PARTNERNAZIV.trimToLength(30) + '</b> ' + $('<p>').html(val.ZADOPIS.trimToLength(100)).text() +'</a>'+
								'<i class="fas fa-share desno posaoPanelLinkNewTab" title="Otvori u novoj kartici"></i></li>';
				html += item;

			});			
			$('#dropdown-posljednji').html(html);       	
        });
	}
	
	function napuniPanelPoslove() {
        // tip 2 - panel  //async
		konto.ek.api.DohvatiPoslovePanel(2).then(function(data) {
        	var html = '';

        	if (data === null || !isset(data))
    			return;
			
			if (typeof data === 'object' && data.error)
				return;
    		
			var btnDodaj = '<li class="nav-item user-data-button btnDodajContainer">' +   			 
    			 '<button class="btn btn-primary btnDodajNaPanel pull right">Dodaj posao na panel</button>' +  
    			 '<button class="btn btn-primary btnPanelObrisiZatvorene pull right">Ukloni zatvorene poslove</button>' +
			 '</li>';
			 
        	ppZatvoreni = [];	
			$.each(data, function(key, val) {
				var item = dodatnaKlasa = naslov = '';
				var zatvoreno = '';
				if (val.ZATVORENO){
				    zatvoreno = 'style="color:green!important"';
				    ppZatvoreni.push(val.POSAOPANEL);    
				}
                
				if(val.OBAVIJEST == 1)
				{
					item  = '<li title="'+naslov+'" class="nav-item user-data-button ppanel-list" data-posao-panel="'+val.POSAOPANEL+'">';
					item += 	'<a href="#" data-posao="'+val.POSAO+'" class="nav-link posaoPanelLink novaObavijest">'+ 					           									
									'<span class="idPosla novaObavijest" ' + zatvoreno + '>' + val.POSAO + '</span> ' + '<span class="nazivAplikacije">'+val.PROG + '</span> ' +
									'<b class="partner novaObavijest">' +val.PARTNERNAZIV.trimToLength(30) + '</b> <span class="novaObavijest">' + $('<p>').html(val.ZADOPIS.trimToLength(100)).text() +'</span></a>'+
								'<i class="far fa-trash-alt desno posaoPanelBrisi" title="Ukloni s liste" style="color:#DA0000"></i>'+
								'<i class="fas fa-share desno posaoPanelLinkNewTab novaObavijest" title="Otvori u novoj kartici"></i></li>';					
				}
				else
				{	
					item  = '<li title="'+naslov+'" class="nav-item user-data-button ppanel-list" data-posao-panel="'+val.POSAOPANEL+'">';
					item += 	'<a href="#" data-posao="'+val.POSAO+'" class="nav-link posaoPanelLink" style="color: black">'+ 									
									'<span class="idPosla" ' + zatvoreno + '>' + val.POSAO + '</span> ' + '<span class="nazivAplikacije">'+val.PROG + '</span> ' +
									'<b class="partner">' +val.PARTNERNAZIV.trimToLength(30) + '</b> ' + val.ZADOPIS.trimToLength(100)+'</a>'+
								'<i class="far fa-trash-alt desno posaoPanelBrisi" title="Ukloni s liste" style="color:#DA0000"></i>'+
								'<i class="fas fa-share desno posaoPanelLinkNewTab" title="Otvori u novoj kartici"></i></li>';
				}
				
				html += item;

			});
			
			$('#dropdown-posaopanel').html(btnDodaj + html);
        });
	}
	
});



/**
 * Jednostavna funkcija za mjerenje vremena izvrsavanja pojedinih funkcija
 * 
 * Koristenje:
 * d = new debug();
 * d.end(bool); 
 */
	debug = function(name) {
	    var e = 0, s = 0;
	    var title = name || false;
	    
	    var __construct = function() {
	        s = new Date().getTime();
	    }();
	    
	    this.end = function(print, xtra) {
	        e = new Date().getTime();
	        r = (e-s);
	        print = print || true; // po defaultu printamo razliku
	        extra = '';
	        if (typeof xtra == 'object')
	            extra = xtra.attr('id');
	            
	        if (print) 
	            if (title) {
	                console.log(title+': '+r+' ms (' + extra+')');
	            } else {
	                console.log('vrijeme: '+r+' ms');
	            }
	            
	        else
	            return r;
	    };
	};